var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var PosAngleData = require("../abstract/posAngleData.js");
var WidthHeightData = require("../abstract/widthHeightData.js");
var SVGToMesh = require("./../threejsExport/svgToMesh.js");
var cio_config = require("cio-config");

var TriangleData = function (center, angle, width, height, fill, strokeWidth, color) {
    this.makeObservableTreeNode();

    this.addPosAngle(center, angle);
    this.addWidthHeight(width, height);

    this.fill = this.value("fill", true, cio_config.types.any.validator);
    this.strokeWidth = this.value("strokeWidth", true, cio_config.types.float.validator);
    this.color = this.value("color", true, cio_config.types.any.validator);

    this.geometry = this.cachedFunction("geometry",
        this._getGeometry,
        [this.pos, this.angle, this.width, this.height]
    );

    this.segmentedGeometry = this.cachedFunction("segmentedGeometry",
        this._getSegmentedGeometry,
        [this.geometry]
    );

    this.boundingBox = this.cachedFunction("boundingBox",
        function () {
            return TriangleData.calculateBoundingBox(this.pos().x, this.pos().y, this.width(), this.height(), this.angle());
        },
        [this.pos, this.angle, this.width, this.height]
    );

    SVGToMesh.call(this);
    

    if (fill != undefined) this.fill(fill);
    if (strokeWidth != undefined) this.strokeWidth(strokeWidth);
    if (color != undefined) this.color(color);
};
lib_core.mixin(TriangleData, lib_core.ObservableTreeNode);
lib_core.mixin(TriangleData, PosAngleData);
lib_core.mixin(TriangleData, WidthHeightData);

module.exports = TriangleData;

lib_core.JsonParser.registerClass(TriangleData, "TriangleData");

TriangleData.prototype.getPoints = function() {
    return [
        new lib_geometry.Coord(-this.width()/2, -this.height()/2)
            .translate(this.pos())
            .rotate(this.angle(), this.pos()),
        new lib_geometry.Coord(0, 0+this.height()/2)
            .translate(this.pos())
            .rotate(this.angle(), this.pos()),
        new lib_geometry.Coord(+this.width()/2, -this.height()/2)
            .translate(this.pos())
            .rotate(this.angle(), this.pos())
    ];
};
 

TriangleData.prototype._getGeometry = function() {
    var geom = new lib_geometry.Trace(this.getPoints()).close();
    return geom;
};

TriangleData.prototype._getSegmentedGeometry = function (precision) {
    return this.geometry().toSegmented(precision);
};

TriangleData.prototype.flip = function(flipLine) {
    PosAngleData.flip.call(this, flipLine);
    this.rotate(180);   // since the axis of symmetry has a 90 degree angle wrt pos x-axis, flipping needs an additional 180 degrees rotation
};

// TriangleData.prototype.expand = function(dest, precision) {
//     var memberName = this.ownerMember._name();
//     var geometryPath = this.segmentedGeometry(precision).toPath();
//     var destination = dest || this.parent(); // if no destination is given, expand in own parent
//     if (!dest) this.remove();   // if expanding in own parent, first remove original generator

//     var path = new PathData(destination.root);
//     path.fromGeometryPath(geometryPath);
//     destination.getMemberByName(memberName).push(path);
// };

TriangleData.calculateBoundingBox = function (cx, cy, width, height, angle) {
    var c = new lib_geometry.Coord(cx, cy);
    var p1 = new lib_geometry.Coord(cx, cy-height/2);
    var p2 = new lib_geometry.Coord(cx-width/2, cy+height/2);
    var p3 = new lib_geometry.Coord(cx+width/2, cy+height/2);
    var pointSet = new lib_geometry.PointSet([p1, p2, p3]);
    pointSet = pointSet.rotate(angle, c);
    return pointSet.getBB();
};
